import { render } from "./TypeMaster.vue?vue&type=template&id=82a683e2&scoped=true"
import script from "./TypeMaster.vue?vue&type=script&lang=js"
export * from "./TypeMaster.vue?vue&type=script&lang=js"

import "./TypeMaster.vue?vue&type=style&index=0&id=82a683e2&scoped=true&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\Edu Katta\\Edukatta_Gov_Eticket\\ui-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-82a683e2"]])

export default __exports__